import styled from 'styled-components';

import theme from 'styles/theme';

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1350px;
  margin: auto;
`;

export const CarouselContainer = styled.div`
  display: flex;
  overflow-x: hidden;
  scroll-behavior: smooth;
  gap: 10px;
  padding: 10px 0;
`;

export const ImageCard = styled.div<{
  active: boolean;
  width: number;
  height: number;
}>`
  flex: 0 0 ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  max-width: 210px;
  max-height: 280px;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;
  z-index: 1;

  &:hover {
    transform: scale(1.02);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: ${({ active }) => (active ? 1 : 0.8)};
    transition: opacity 0.3s ease-in-out;
  }
`;

export const StyledButton = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 128px;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
  z-index: 2;

  &:hover {
    opacity: 1;
  }

  button {
    width: 100%;
    background-color: ${theme.COLORS.PRIMARY};
    color: ${theme.COLORS.GRAY_10};
    border: none;
    border-radius: 4px;
    cursor: pointer;
    padding: 8px 16px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;

    &:hover {
      background-color: ${theme.COLORS.PRIMARY};
    }
  }
`;

export const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
`;
